/* ============================================================================
   Perfil do administrador.
   ============================================================================ */
import { useState, useEffect } from 'react';
import api from '../../services/api';
import AdminLayout from '../components/AdminLayout';
import PageHeader from '../components/PageHeader';
import { Field, TextInput } from '../components/Field';
import { Loading } from '../components/ui';
import { toast } from '../components/Toast';
import { updateUser } from '../lib/auth';
import { IconEye, IconEyeOff, IconSave } from '../components/icons';
import './Profile.css';

export default function Profile() {
  const [form, setForm] = useState({ name: '', email: '', phone: '', adminId: '' });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [showAdminId, setShowAdminId] = useState(false);

  const set = (patch) => setForm((f) => ({ ...f, ...patch }));

  useEffect(() => {
    (async () => {
      try {
        const res = await api.get('/admin/profile', true);
        if (res.success) set({ name: res.data.name || '', email: res.data.email || '', phone: res.data.phone || '', adminId: res.data.adminId || '' });
      } catch { toast.error('Erro ao carregar o perfil.'); }
      finally { setLoading(false); }
    })();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const res = await api.put('/admin/profile', form, true);
      if (res.success) {
        updateUser({ name: res.data.name, email: res.data.email, phone: res.data.phone, adminId: res.data.adminId });
        toast.success('Perfil atualizado.');
      }
    } catch (err) { toast.error(err.message || 'Erro ao atualizar o perfil.'); }
    finally { setSaving(false); }
  };

  return (
    <AdminLayout narrow>
      <PageHeader title="Meu perfil" subtitle="Atualize suas informações de administrador" />
      {loading ? <Loading /> : (
        <form className="mg-card mg-card-pad-lg" onSubmit={handleSubmit}>
          <div className="mg-field-row">
            <Field label="Nome completo" required>
              <TextInput value={form.name} onChange={(e) => set({ name: e.target.value })} placeholder="Seu nome completo" required />
            </Field>
            <Field label="E-mail" required>
              <TextInput type="email" value={form.email} onChange={(e) => set({ email: e.target.value })} placeholder="seu@email.com" required />
            </Field>
          </div>
          <div className="mg-field-row">
            <Field label="Telefone" required>
              <TextInput value={form.phone} onChange={(e) => set({ phone: e.target.value })} placeholder="+55 11 98912-6963" required />
            </Field>
            <Field label="ID de administrador" required hint="Guarde este ID em local seguro.">
              <div className="profile-secret">
                <TextInput type={showAdminId ? 'text' : 'password'} value={form.adminId} onChange={(e) => set({ adminId: e.target.value })} placeholder="admin-id-secreto" required />
                <button type="button" className="mg-icon-btn" onClick={() => setShowAdminId((v) => !v)} aria-label="Mostrar/ocultar">
                  {showAdminId ? <IconEyeOff size={16} /> : <IconEye size={16} />}
                </button>
              </div>
            </Field>
          </div>
          <div className="profile-actions">
            <button type="submit" className="mg-btn mg-btn-primary" disabled={saving}>
              {saving ? <><span className="mg-spinner mg-spinner-sm" /> Salvando…</> : <><IconSave size={16} /> Salvar alterações</>}
            </button>
          </div>
        </form>
      )}
    </AdminLayout>
  );
}
